type HardwareComponentIdentity = {
  componentKey?: string | null
  label?: string | null
}

function normalizedLabel(value: string | null | undefined) {
  return String(value || '').trim().toLocaleLowerCase('zh-CN').replace(/\s+/g, '')
}

function normalizedComponentKey(value: string | null | undefined) {
  return String(value || '').trim().toLocaleLowerCase('zh-CN')
}

export function hardwareComponentKey(
  componentKey: string | null | undefined,
  label: string | null | undefined,
) {
  const normalizedKey = normalizedComponentKey(componentKey)
  return normalizedKey ? `key:${normalizedKey}` : `label:${normalizedLabel(label)}`
}

export function hardwareComponentsMatch(
  requirement: HardwareComponentIdentity,
  specification: HardwareComponentIdentity,
) {
  const requirementKey = normalizedComponentKey(requirement.componentKey)
  const specificationKey = normalizedComponentKey(specification.componentKey)
  if (requirementKey && specificationKey) return requirementKey === specificationKey
  return normalizedLabel(requirement.label) === normalizedLabel(specification.label)
}
